module.exports = __webpack_public_path__ + "static/index/img/baikal-504.61452352.jpg";